import { loadScript } from '@/modules/upload/cloud/loadScript'

// The parts of Dropbox's Chooser (dropins.js) this app uses.
// https://www.dropbox.com/developers/chooser
export interface DropboxChooserFile {
  name: string
  link: string
  bytes: number
}

export interface DropboxChooserOptions {
  success: (files: DropboxChooserFile[]) => void
  cancel: () => void
  linkType: 'direct' | 'preview'
  multiselect: boolean
  extensions: string[]
  sizeLimit: number
}

export interface DropboxChooser {
  choose: (options: DropboxChooserOptions) => void
  isBrowserSupported: () => boolean
}

declare global {
  interface Window {
    Dropbox?: DropboxChooser
  }
}

export const DROPINS_SCRIPT_ID = 'dropboxjs'
export const DROPINS_SCRIPT_URL =
  'https://www.dropbox.com/static/api/2/dropins.js'

export const loadDropins = (appKey: string): Promise<boolean> => {
  if (window.Dropbox) return Promise.resolve(true)
  return loadScript({
    id: DROPINS_SCRIPT_ID,
    src: DROPINS_SCRIPT_URL,
    dataset: { appKey },
  })
}
